var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"--description"},[_c('cms-page',{attrs:{"page-id":244,"content-only":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }